/** @jsxImportSource @emotion/react */
import React from 'react'
import { useGetBillingNotesQuery } from 'store/services/billingNotes'
import { BillingNotes, NoteEntity } from './BillingNotes'

// A charge's own notes, the thread its row and page show, for screens that
// work on the charge without its row in view (the Apply Payment modal). A note
// is saved the moment it is added, so closing such a screen loses nothing.
export const ChargeNotes: React.FC<{ chargeId?: string }> = ({ chargeId }) => {
  const { currentData: notes } = useGetBillingNotesQuery(
    { type: NoteEntity.CHARGE, entityId: String(chargeId) },
    { skip: !chargeId },
  )

  if (!chargeId) {
    return (
      <div css={{ color: '#6c757d', fontStyle: 'italic', fontSize: '0.813rem' }}>
        Select the charge to see and add its notes
      </div>
    )
  }

  if (!notes) {
    return <div css={{ color: '#6c757d', fontSize: '0.813rem' }}>Loading notes...</div>
  }

  return <BillingNotes notes={notes} type={NoteEntity.CHARGE} entityId={chargeId} />
}
